import { Injectable } from '@angular/core';
import { FC_MotherDisco } from '../funcionesCompatibilidad/FC_MotherDisco';
import { Incompatibilities } from '../Incompatibilities';
import { Disco } from '../model';
import { DataArmado } from './DataArmado';
import { FuncionesArmadoBase } from './FuncionesArmadoBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FA_Disco extends FuncionesArmadoBase<Disco> {
  constructor(private fc_motherDisco: FC_MotherDisco) {
    super();
  }

  private asignarInterfazM2(tipoDisco, disco): string {
    if (tipoDisco == 'm2') {
      return (tipoDisco = tipoDisco + '_' + disco.$caracteristicas.interfaz.toLowerCase());
    } else {
      return tipoDisco;
    }
  }

  funciones = {
    // TODO: si el disco es incompatible con la mother debería tener solo una incompatibilidad e ignorar la de cantidad
    mother: (dataArmado: DataArmado, disco: Disco) => {
      const motherEnArmado = dataArmado.mother[0];
      if (!motherEnArmado) return [];
      return this.fc_motherDisco.ejecutar(motherEnArmado, disco);
    },
    cantidad: (dataArmado: DataArmado, disco: Disco): Incompatibilities[] => {
      let tipoDisco = this.asignarInterfazM2(disco.$caracteristicas.tipo.toLowerCase(), disco);
      let cantidadMaxima = { sata: 5, m2_nvme: 1, m2_sata: 1 };
      let mother = dataArmado.mother[0];
      if (mother) {
        cantidadMaxima.sata = mother.$caracteristicas.SATA;
        cantidadMaxima.m2_nvme = mother.$caracteristicas.m2_nvme;
        cantidadMaxima.m2_sata = mother.$caracteristicas.m2_sata;
      }

      let cantidadDiscosSeleccionados = dataArmado.discos.reduce(
        (result, discoActual) => {
          let tipoDiscoActual = discoActual.$caracteristicas.tipo.toLowerCase();
          tipoDiscoActual = this.asignarInterfazM2(tipoDiscoActual, discoActual);
          let cantidad: number = result[tipoDiscoActual] + 1 || 1;
          result[tipoDiscoActual] = cantidad;
          return result;
        },
        {} as { [x: string]: number },
      );

      const incompatibilidades: Array<Incompatibilities> = [];
      let saldo: number = cantidadMaxima.sata + cantidadMaxima.m2_sata + cantidadMaxima.m2_nvme;

      for (const tipo in cantidadDiscosSeleccionados) {
        if (cantidadMaxima[tipo] < cantidadDiscosSeleccionados[tipo] && tipo == tipoDisco) {
          incompatibilidades.push({
            tipo: IncompatibilitiesType.ARMADO,
            incompatibility: `Excede la cantidad máxima de discos ${tipo.toUpperCase()}`,
          });
        }
        if (cantidadMaxima[tipo] == cantidadDiscosSeleccionados[tipo] && tipo == tipoDisco) {
          incompatibilidades.push({
            tipo: IncompatibilitiesType.PARCIAL,
            incompatibility: `La mother no soporta otro disco ${tipo.toUpperCase()}`,
          });
        }
        saldo -= cantidadDiscosSeleccionados[tipo];
      }

      if (!saldo) {
        if (dataArmado.discos.some((d) => d.id_producto == disco.id_producto)) {
          return [
            {
              tipo: IncompatibilitiesType.DEFAULT_STOCK,
              incompatibility: '',
            },
          ];
        }
        incompatibilidades.push({
          tipo: IncompatibilitiesType.CANTIDAD,
          incompatibility: `La mother no soporta más discos SATA ni M2`,
        });
      }
      return incompatibilidades?.length ? incompatibilidades : null;
    },
    capacidadGabinete: (dataArmado: DataArmado, disco: Disco): Incompatibilities[] => {
      let dimensionDisco = disco.$caracteristicas.dimension.toString();
      if (dimensionDisco == 'M2') return [];
      const incompatibilidades: Array<Incompatibilities> = [];
      let gabinete = dataArmado.gabinetes[0];
      if (!gabinete) return [];

      let cantidadMaxima = {
        unidades_2_5: gabinete.$caracteristicas.unidades_2_5,
        unidades_3_5: gabinete.$caracteristicas.unidades_3_5,
        unidades_3_25: gabinete.$caracteristicas.unidades_3_25,
      };

      let cantidadDiscosSeleccionados = dataArmado.discos.reduce(
        (result, discoActual) => {
          let dimensionDiscoActual = discoActual.$caracteristicas.dimension.toString();
          let cantidad: number = result[dimensionDiscoActual] + 1 || 1;
          result[dimensionDiscoActual] = cantidad;
          return result;
        },
        {} as { [x: string]: number },
      );
      let saldo: number = Object.values(cantidadMaxima).reduce(
        (acum, actual) => acum + Number(actual),
        0,
      );
      const equivalenciaDimension = {
        '2.5': 'unidades_2_5',
        '3.5': 'unidades_3_5',
        '3.25': 'unidades_3_25',
      };
      for (const dimension in cantidadDiscosSeleccionados) {
        if (
          cantidadDiscosSeleccionados[dimension] >
            cantidadMaxima[equivalenciaDimension[dimension]] &&
          dimension == dimensionDisco
        ) {
          incompatibilidades.push({
            tipo: IncompatibilitiesType.ARMADO,
            incompatibility: `Excede la cantidad máxima de discos ${dimension.toUpperCase()}`,
          });
        }
        if (
          cantidadMaxima[equivalenciaDimension[dimension]] ==
            cantidadDiscosSeleccionados[dimension] &&
          dimension == dimensionDisco
        ) {
          incompatibilidades.push({
            tipo: IncompatibilitiesType.PARCIAL,
            incompatibility: `El gabinete no soporta otro disco ${dimension.toUpperCase()}`,
          });
        }
        saldo -= cantidadDiscosSeleccionados[dimension];
      }

      if (!saldo) {
        incompatibilidades.push({
          tipo: IncompatibilitiesType.CANTIDAD,
          incompatibility: `El gabinete no soporta más discos sata`,
        });
      }

      return incompatibilidades?.length ? incompatibilidades : null;
    },
    capacidadFuente: (dataArmado: DataArmado, disco: Disco): Incompatibilities[] => {
      const gabinete = dataArmado.gabinetes[0];
      let fuenteEnArmado = dataArmado.fuentes[0];
      if (!fuenteEnArmado) {
        if (
          gabinete?.$caracteristicas?.kit == 1 &&
          gabinete?.$caracteristicas?.$caracteristicas_fuente
        ) {
          fuenteEnArmado = gabinete?.$caracteristicas?.$caracteristicas_fuente;
        }
        let discosSata = dataArmado.discos?.filter(
          (d) => d.$caracteristicas.interfaz.toLowerCase() == 'sata',
        );
        if (disco.$caracteristicas.interfaz.toLowerCase() == 'sata') {
          discosSata.push(disco);
        }
        return fuenteEnArmado?.$caracteristicas?.sata < discosSata?.length ?
            [
              {
                tipo: IncompatibilitiesType.CANTIDAD,
                incompatibility: `La fuente no soporta más discos SATA`,
              },
            ]
          : null;
      }
    },
  };
}
